import { render, staticRenderFns } from "./xundetail.vue?vue&type=template&id=37e36e09&scoped=true"
import script from "./xundetail.vue?vue&type=script&lang=js"
export * from "./xundetail.vue?vue&type=script&lang=js"
import style0 from "./xundetail.vue?vue&type=style&index=0&id=37e36e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e36e09",
  null
  
)

export default component.exports